import { render } from "./DemoSlices.vue?vue&type=template&id=5ea59dd4&scoped=true&ts=true"
import script from "./DemoSlices.vue?vue&type=script&lang=ts"
export * from "./DemoSlices.vue?vue&type=script&lang=ts"

import "./DemoSlices.vue?vue&type=style&index=0&id=5ea59dd4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea59dd4"]])

export default __exports__